import React from 'react';
import PropTypes from 'prop-types';

import { pathTo } from '../../App/routes';

import Team from './Team';
import Pagination from '../shared/Pagination';
import Spinner from '../shared/Spinner';
import Title from '../shared/Title';
import ItemSelector from '../shared/ItemSelector';
import SearchBox from '../shared/SearchBox';

const CHOOSE_LEAGUE = 'Choose a league and a season to see your team list';
const CHOOSE_TEAM = 'Select a team';

const TeamSelection = ({
  teams,
  teamsCurrentPage,
  teamsPageSize,
  teamsCount,
  leagues,
  league,
  seasons,
  season,
  teamName,
  onPageChange,
  onLeagueChange,
  onSeasonChange,
  onTeamNameChange,
}) => {
  const subtitle = teams ? CHOOSE_TEAM : CHOOSE_LEAGUE;
  return (
    <div className="s-teams">
      <Title title="Teams" linkTo="" subtitle={subtitle} />

      <div className="filter-container">
        <div className="filter filter--big">
          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <ItemSelector
                  title="League"
                  items={leagues}
                  value={league}
                  onChange={onLeagueChange}
                  testId="team-selection-filter-league"
                />
              </div>
            </div>

            <div className="form-column">
              <div className="form-group">
                <ItemSelector
                  title="Season"
                  items={seasons}
                  value={season}
                  onChange={onSeasonChange}
                  testId="team-selection-filter-season"
                  disabledText="The league has no seasons"
                />
              </div>
            </div>

            <div className="form-column">
              <div className="form-group">
                <SearchBox
                  value={teamName}
                  placeholder="Search by name..."
                  disabled={!teams || (teams.length === 0 && !teamName)}
                  disabledText="Selection has no Teams"
                  onChange={onTeamNameChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {league && season && teams && (
        <TeamList teams={teams} league={league} season={season} />
      )}

      {!league ? <Spinner /> : ''}

      <Pagination
        current={teamsCurrentPage}
        totalItems={teamsCount}
        pageSize={teamsPageSize}
        onChange={onPageChange}
      />
    </div>
  );
};

TeamSelection.propTypes = {
  teams: PropTypes.array,
  leagues: PropTypes.array,
  userId: PropTypes.string,
  teamName: PropTypes.string,
};

export default TeamSelection;

const TeamList = ({ teams, league, season }) => (
  <div className="s-teams__list">
    {teams.map(team => (
      <Team
        key={team.id}
        team={team}
        url={pathTo('team', league, season, team)}
      />
    ))}
  </div>
);
